import Vue from "vue";

export default function () {
  // 格式化音视频时长
  function formatFileLength(time) {
    if (time > -1) {
      var hour = Math.floor(time / 3600);
      var min = Math.floor(time / 60) % 60;
      var sec = time % 60;
      time = sec + "秒";
      if (min > 0) time = min + "分" + time;
      if (hour > 0) time = hour + "小时" + time;
    }
    return time;
  }
  Vue.prototype.$formatFileLength = formatFileLength;
}
